<template>
	<div>
		<Popup
			v-model:show="personalTag"
			position="bottom"
			closeable
			round
			:close-on-click-overlay="false"
			:style="{ height: '490px' }"
			@click="cancelInput"
		>
			<div style="font-size: var(--base-px-14);font-weight: bold;text-align: center;padding-top: var(--base-px-15);">添加个人标签
			</div>
			<Divider/>
			<div style="display: flex;">
				<van-button type="default" class="add_btn" @click.stop="showAddInput">
					<van-icon name="plus"/>
					添加标签
				</van-button>
				<input
					type="text"
					class="add_input"
					placeholder="输入后回车"
					v-if="showInput"
					@click.stop
					@keyup.enter="addTemplate"
					v-model="tagName"
					style="padding-left: var(--base-px-5);"
					ref="tagInput"
				/>
			</div>
			<div class="show_tag_list" style="height: 315px;">
				<div style="display: flex;flex-wrap: wrap;">
					<div
						class="name-tags"
						v-for="(item,index) in listTags"
						:key="index"
						:class="[(addTagArray.indexOf(item)!=-1)?'selectTag':'']"
						@click="addTagsArray(item)"
					>{{ item.name }}
						<van-icon name="clear" class="close-icon" @click.stop="deleteTag(item)"/>
					</div>
				</div>
			</div>
			<div class="foot_btn_row">
				<van-button type="info" block @click="clientAddTags">保存</van-button>
			</div>
		</Popup>
	</div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import {ContactEmployeeTagApi} from '@/api/contactEmployeeTag'
// eslint-disable-next-line no-unused-vars
import {Popup, Divider, Toast, Dialog} from 'vant'

export default {
	components: {
		Popup, Divider
	},
	data() {
		return {
			personalTag: false,
			showInput: false,
			// 标签名称
			tagName: '',
			listTags: [],
			addTagArray: []
		}
	},
	methods: {
		show(contactId) {
			this.contactId = contactId
			this.personalTag = true
			this.getTabsList()
		},
		// 显示标签输入框
		showAddInput() {
			this.showInput = true
			this.$nextTick(() => {
				this.$refs.tagInput.focus()
			})
		},
		// 获取标签列表
		getTabsList() {
			ContactEmployeeTagApi.index({
				contactId: this.contactId
			}).then((res) => {
				this.listTags = res.data
				this.getSelectTabs()
			})
		},
		// 初始化标签数组
		getSelectTabs() {
			this.addTagArray = []
			this.listTags.forEach((item, index) => {
				if (item.isSelect == 1) {
					this.addTagArray.push(item)
				}
			})
		},
		addTagsArray(item) {
			const tagIndex = this.addTagArray.indexOf(item)
			if (tagIndex == -1) {
				this.addTagArray.push(item)
			} else {
				this.addTagArray.splice(tagIndex, 1)
			}
		},
		// 给客户添加标签
		clientAddTags() {
			if (this.addTagArray.length == 0) {
				Toast('请选择标签')
				return false
			}
			const tagIds = this.addTagArray.map((item, index) => {
				return item.id
			})
			ContactEmployeeTagApi.employeeTagStore({
				contactId: this.contactId,
				tagIds
			}).then((res) => {
				Toast('设置成功')
				this.personalTag = false
				this.$emit('change', true)
			})
		},
		// 添加标签
		addTemplate() {
			ContactEmployeeTagApi.store({
				name: this.tagName
			}).then((res) => {
				Toast('添加成功')
				this.getTabsList()
				this.tagName = ''
				this.showInput = false
			})
		},
		// 删除标签
		deleteTag(item) {
			Dialog.confirm({
				message: '是否删除该标签'
			}).then(() => {
				ContactEmployeeTagApi.destroy({
					id: item.id
				}).then((res) => {
					Toast('删除成功')
					this.getTabsList()
				})
			}).catch(() => {
			})
		},
		cancelInput() {
			this.showInput = false
		}
	}
}
</script>
<style scoped lang="less">
.add_btn {
	border: var(--base-px-1) dashed #2C9AFF;
	height: var(--base-px-25);
	font-size: var(--base-px-12);
	color: #2C9AFF;
	padding: 0 var(--base-px-5);
	margin-left: var(--base-px-15);
}

.add_input {
	width: var(--base-px-75);
	height: var(--base-px-25);
	margin-left: var(--base-px-10);
	border: var(--base-px-1) solid #CDE5F9;
	font-size: var(--base-px-14);
}

.show_tag_list {
	overflow-y: scroll;
}

.foot_btn_row {
	margin: var(--base-px-25) auto 0;
	width: calc(100% - var(--base-px-50));
}

.name-tags {
	border: var(--base-px-1) solid #CDE5F9;
	background: #F7F7F7;
	padding: var(--base-px-5) var(--base-px-10);
	border-radius: var(--base-px-4);
	margin-top: var(--base-px-15);
	margin-left:  var(--base-px-13);
	font-size: var(--base-px-14);
	height: var(--base-px-30);
	position: relative;
	cursor: pointer;
	box-sizing: content-box;
}

.selectTag {
	background: #45A5FE;
	color: #fff;
	border: var(--base-px-1) solid #45A5FE;
}

.close-icon {
	font-size: var(--base-px-14);
	margin-left:  var(--base-px-3);
	position: absolute;
	top: var(--base-px--7-5);
	right: var(--base-px--4);
	z-index: 100;
	color: #7E99B0;
}

.selectTag .close-icon {
	color: #90B9DE;
}
</style>
